import React from 'react';
import NewTabulator from "../NewTabulator/NewTabulator";
import {deleteRowHandlerInFactor} from "../BuyFactorSadan/FactorNewDetails/functions";
import {calculateNewDataInFactor} from "../BuyFactorSadan/FactorFunctions";
import {parseToEnRemoveComma} from "../../utils/CommaSeparator";
import tableCalc from "../../utils/tableCalc";
import {useDispatch, useSelector} from "react-redux";
import {requestTableDataReview, reviewAccountAction, reviewAccountSlice} from "../Store/ReviewAccountsStore";

function TableViewReviewAccount() {

  const data = useSelector(s => s.reviewAccountReducer);

  const dispatch = useDispatch()
  if (data.showLoadingInTable === true) {
    return <>در حال بارگزاری اطلاعات</>
  }

  const myTableEvents = {
    selectedRow:data.selectedRowAccountCode,


    rowClick: (selectedRow) => {

      let accountCode;
      /*
       یه نکته ای هست
      اگه کاربر بیاد پایین بک اند لول رو عوض میکنه
      اما اگه بره بالا لول رو عوض نمیکنه
      حالا من در صورتی که کاربر بره بالا باید اکانت کدی که میدم همون اکانت کد اولی باشه.
      ولی اگه اومد پایین باید اکانت کدی رو ست کنم که جدیده

       */
      // if ((selectedRow.currentLevel > data.prevLevel) || data.prevLevel === '') {
      //   accountCode = selectedRow.accountCode
      // } else {
      //   accountCode = data.accountCode
      // }
      accountCode = selectedRow?.accountCode


      // اینجا استثنا باید مقدار لول رو بزاریم توی پریو_لول

      const prevLevel = selectedRow.currentLevel
      const newHandlerButton = {...data.handlerButton}
      for (const key in newHandlerButton) {
        newHandlerButton[key] = true
      }


      if (data.myData.passedLevels.includes(0)) newHandlerButton.group = false
      if (data.myData.passedLevels.includes(1)) newHandlerButton.kol = false
      if (data.myData.passedLevels.includes(2)) newHandlerButton.moein = false
      if (data.myData.passedLevels.includes(3)) newHandlerButton.tafsili = false


      // if (data.myData.mainCurrentLevel === 0) newHandlerButton.group = false
      // if (data.myData.mainCurrentLevel === 1) newHandlerButton.kol = false
      // if (data.myData.mainCurrentLevel === 2) newHandlerButton.moein = false
      // if (data.myData.mainCurrentLevel === 3) newHandlerButton.tafsili = false

      dispatch(reviewAccountAction.fillInput({
        showHandlers: true,
        handlerButton: newHandlerButton,
        accountCode,
        prevLevel,

      }))

    },
    rowDoubleClick: (selectedRow) => {
      const newLevel = selectedRow.currentLevel;
      console.log(selectedRow);

      const accountCode = selectedRow.accountCode;
      dispatch(requestTableDataReview(
        {
          level: newLevel,
          accountCode,
          mode: 'details',
          passedAccounts:data.passedAccounts,
          filters:JSON.stringify(data.filterValues)
        }
      ))
    }
  }
  return (
    <div className={''}>
      {/*<div*/}
      {/*  onClick={() => dispatch(reviewAccountAction.fillInput({showHandlers: !data.showHandlers}))}*/}
      {/*>*/}
      {/*  تست دیسپتچ*/}
      {/*</div>*/}
      {<NewTabulator
        columns={data.myData.column}
        data={data.myData.data}
        style={{height: "55vh", overflow: 'scroll'}}
        className={"newTabulator__review__account"}
        events={myTableEvents}
      />}
    </div>
  );
}

export default TableViewReviewAccount;